<div class="analysis-view">
  <div class="canvas-header">
    <div class="header-left">
      <mat-icon class="header-icon">analytics</mat-icon>
      <h2>{{ analysisResult?.title || analysisResult?.query || ('Questions.AnalysisReport' | translate) }}</h2>
    </div>

    <div id="header-toolbar" style="visibility: hidden; flex: 1;"></div>

    <div class="actions">
      <button mat-icon-button (click)="closeView()" [matTooltip]="'GenerateContent.Close' | translate">
        <mat-icon>close</mat-icon>
      </button>
    </div>
  </div>

  <div class="canvas-content">
    <!-- Summary/Main Content -->
    @if (analysisResult?.summary) {
      <markdown [data]="analysisResult?.summary"></markdown>
    } @else if (analysisResult?.result) {
      <markdown [data]="analysisResult?.result"></markdown>
    } @else {
      <markdown [data]="analysisResult | json"></markdown>
    }

    <!-- Results Section -->
    @if (analysisResult) {
      <div class="results-container mt-4">
        <div class="results-header">
          <h2 class="results-heading">
            <mat-icon class="mr-2 text-primary">analytics</mat-icon>
            {{ 'Questions.ResultsTitle' | translate }}
          </h2>
        </div>

        <div class="skz-card results-card">
          <!-- Metadata Bar -->
          <div class="meta-bar">
            <div class="meta-item">
              <mat-icon>database</mat-icon>
              <span>{{ 'Questions.SourceLabel' | translate: { count: totalLength } }}</span>
            </div>
            <div class="meta-item">
              <mat-icon>schedule</mat-icon>
              <span>{{ analysisResult.createdAt | date: 'medium' }}</span>
            </div>
          </div>

          <div class="card-content">
            <!-- Global Summary -->
            <div class="summary-section">
              <h3 class="section-title">{{ 'Questions.GlobalSummary' | translate }}</h3>
              <div class="markdown-body">
                <markdown [data]="analysisResult.summary"></markdown>
              </div>
            </div>

            <div class="row mt-4">
              <!-- Top Questions -->
              <div class="col-lg-7 mb-4">
                <h3 class="section-title">{{ 'Questions.TopQuestions' | translate }}</h3>
                <div class="questions-list">
                  @for (q of analysisResult.topQuestions; track q; let i = $index) {
                    <div class="question-item">
                      <div class="rank-badge">{{ i + 1 }}</div>
                      <div class="question-content">
                        <div class="question-text">{{ q.text }}</div>
                        <div class="question-stats">
                          <span class="stat-pill">
                            <mat-icon>visibility</mat-icon>
                            {{ q.count }}
                          </span>
                          @if (q.trend === 'up') {
                            <span class="stat-trend up">
                              <mat-icon>trending_up</mat-icon>
                            </span>
                          } @else if (q.trend === 'down') {
                            <span class="stat-trend down">
                              <mat-icon>trending_down</mat-icon>
                            </span>
                          }
                        </div>
                      </div>
                    </div>
                  }
                </div>
              </div>

              <!-- Key Insights -->
              <div class="col-lg-5">
                <h3 class="section-title">{{ 'Questions.KeyInsights' | translate }}</h3>
                <div class="insights-stack">
                  @for (insight of analysisResult.insights; track insight) {
                    <div class="insight-card">
                      <div class="insight-icon" [ngClass]="insight.icon === 'warning' ? 'warning' : 'primary'">
                        <mat-icon>{{ insight.icon }}</mat-icon>
                      </div>
                      <div class="insight-body">
                        {{ insight.text }}
                      </div>
                    </div>
                  }
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    }
  </div>
</div>
